module.exports = __webpack_public_path__ + "static/03-5b8a349aa5b680e61edc52e56beabbc1.jpg";